export const Article = {
  Name: "name" as const,
  UnitPrice: "unitPrice" as const,
  Vat: "vat" as const,
  VatText: "vatText" as const,
  UnitId: "unitId" as const,
  Unit: "unit" as const,
  EuVatCategoryId: "euVatCategoryId" as const,
  EuVatCategory: "euVatCategory" as const,
  Account: "account" as const,
  AccountName: "accountName" as const,
  Active: "active" as const,
}

export const Filter = {
  UnitId: "unitId" as const,
  UpdatedAfter: "updatedAfter" as const,
  Active: "active" as const,
  Name: "name" as const,
  EuVatProductType: "euVatProductType" as const,
  UnitPrice: "unitPrice" as const,
  TotalAmountForLastYearlyPeriod: "totalAmountForLastYearlyPeriod" as const,
  TotalQuantityForLastYearlyPeriod: "totalQuantityForLastYearlyPeriod" as const,
}

export const ImportArticle = {
  Name: "name" as const,
  Vat: "vat" as const,
  Unit: "unit" as const,
  StandardPrice: "standardPrice" as const,
  EuVatProductType: "euVatProductType" as const,
  CsvUpload: "csvUpload" as const,
  Delimiter: "delimiter" as const,
}

